import React from 'react'
import { RatingKey } from '../RatingKey'

export default () => (
  <div className="column__main">
    <div className="column__three column--merge-a">
      <RatingKey />
    </div>
  </div>
)
